/**
 * TanStack Router: /employees
 *
 * This route file was auto-generated by the route generation script.
 * Component: EmployeesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import EmployeesPage from '@/app/employees/page'

/**
 * Route: /employees
 * Layout: _auth (authenticated)
 * Component: EmployeesPage
 */
export const Route = createFileRoute('/_auth/employees')({
  component: EmployeesPage,
})
